/**
 * Path público do deal: preferencialmente nº do pedido (`url_key` / `internal_number`).
 */
export function ploomesDealPath(deal: {
    id: number;
    url_key?: string | null;
    internal_number?: string | number | null;
}): string {
    const key = deal.url_key?.toString().trim();
    if (key) {
        return `/ploomes-deals/${key}`;
    }

    const pedido = deal.internal_number?.toString().trim();
    if (pedido) {
        return `/ploomes-deals/${pedido}`;
    }

    return `/ploomes-deals/${deal.id}`;
}
